import { render, staticRenderFns } from "./rateManagement.vue?vue&type=template&id=536c31f0&scoped=true&"
import script from "./rateManagement.vue?vue&type=script&lang=js&"
export * from "./rateManagement.vue?vue&type=script&lang=js&"
import style0 from "./rateManagement.vue?vue&type=style&index=0&id=536c31f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536c31f0",
  null
  
)

export default component.exports